import {useContext} from 'react';
import {
  DocumentCreationActionsContext,
  DocumentCreationActionsContextValue,
} from '@/components/new-document-creation/dialog/context/document-create-actions.context';

export const useDocumentCreationActions = (): DocumentCreationActionsContextValue => {
  const context = useContext(DocumentCreationActionsContext);
  if (!context) {
    throw new Error('useDocumentCreationActions must be used within a DocumentCreationActionsProvider');
  }
  return context;
};
